import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Drawer from "@mui/material/Drawer";
import useResponsive from "hooks/useResponsive";
import { NAV } from "config";
import Logo from "components/logo";
import Scrollbar from "components/scrollbar";
import { NavSectionVertical } from "components/nav-section";
import navConfig from "./config";
import { useSelector } from "react-redux";
import "./nav.css";
import _ from "lodash";

export default function NavVertical({ openNav, onCloseNav }) {
  const { pathname } = useLocation();
  const isDesktop = useResponsive("up", "lg");
  const { studentLoader, studentById } = useSelector((state) => state.student);

  useEffect(() => {
    if (openNav) {
      onCloseNav();
    }
  }, [pathname]);

  const filteredData =
    studentById?.courseId == 4
      ? navConfig?.map((obj) => ({
          items: obj?.items?.filter(
            (item) => item?.title !== "Doubts" && item?.title !== "Study",
          ),
        }))
      : navConfig?.map((obj) => ({
          items: obj?.items?.filter((item) => item?.title !== "My Learning"),
        }));

  const renderContent = (
    <Scrollbar
      sx={{
        height: 1,
        "& .simplebar-content": {
          height: 1,
          display: "flex",
          flexDirection: "column",
        },
      }}
    >
      <Stack
        spacing={3}
        sx={{
          pt: 3,
          pb: 2,
          px: 2.5,
          flexShrink: 0,
          alignItems: "center",
        }}
      >
        <Logo />
        {/*<NavAccount isOpen={isOpen} setIsOpen={setIsOpen} /> */}
      </Stack>
      <NavSectionVertical data={filteredData} />
      <Box sx={{ flexGrow: 1 }} />
    </Scrollbar>
  );

  return (
    <Box
      component="nav"
      sx={{
        flexShrink: { lg: 0 },
        width: { lg: NAV.W_DASHBOARD },
      }}
    >
      {isDesktop ? (
        <Drawer
          open
          variant="permanent"
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
              bgcolor: "#fff",
              borderRight: "none",
            },
          }}
        >
          {renderContent}
        </Drawer>
      ) : (
        <Drawer
          open={openNav}
          onClose={onCloseNav}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: {
              width: NAV.W_DASHBOARD,
              bgcolor: "#fff",
            },
          }}
        >
          {renderContent}
        </Drawer>
      )}
    </Box>
  );
}
